<template>
  <div class="banner-manage">


    <!-- 搜索栏 -->
    <el-card class="search-bar" shadow="never">
      <el-form :inline="true" :model="query" @submit.native.prevent>
        <el-form-item label="运营位">
          <el-select v-model="query.positionId" placeholder="全部" clearable style="width:160px">
            <el-option v-for="p in positions" :key="p.id" :label="p.name" :value="p.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="全部" clearable style="width:120px">
            <el-option label="草稿" :value="0" />
            <el-option label="已发布" :value="1" />
            <el-option label="已下架" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="query.keyword" placeholder="模糊搜索" clearable style="width:200px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 操作栏 + 列表 -->
    <el-card shadow="never">
      <div class="toolbar">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增 Banner</el-button>
      </div>

      <el-table v-loading="loading" :data="tableData" border stripe row-key="id">
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column label="图片预览" width="140" align="center">
          <template slot-scope="{ row }">
            <el-image
              :src="row.imageFullUrl"
              :preview-src-list="[row.imageFullUrl]"
              fit="cover"
              style="width:100px;height:44px;border-radius:4px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="标题" min-width="140" show-overflow-tooltip />
        <el-table-column prop="positionName" label="所属运营位" width="150" />
        <el-table-column prop="linkTypeText" label="跳转类型" width="110" align="center" />
        <el-table-column prop="sortOrder" label="排序权重" width="100" align="center" sortable />
        <el-table-column label="生效时间" width="220" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.startTime">{{ formatTime(row.startTime) }}</span>
            <span v-else>立即生效</span>
            <span> ~ </span>
            <span v-if="row.endTime">{{ formatTime(row.endTime) }}</span>
            <span v-else>永久</span>
          </template>
        </el-table-column>
        <el-table-column prop="statusText" label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.status)">{{ row.statusText }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="clickCount" label="点击数" width="80" align="center" />
        <el-table-column label="操作" width="260" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button size="mini" type="primary" @click="handleEdit(row)">编辑</el-button>
            <el-button
              v-if="row.status !== 1"
              size="mini"
              type="success"
              @click="handlePublish(row)"
            >上架</el-button>
            <el-button
              v-if="row.status === 1"
              size="mini"
              type="warning"
              @click="handleOffline(row)"
            >下架</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size.sync="query.pageSize"
        :current-page.sync="query.pageNum"
        :page-sizes="[10, 20, 50]"
        @current-change="fetchList"
        @size-change="fetchList"
      />
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="640px"
      @close="resetForm"
    >
      <el-form ref="formRef" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="所属运营位" prop="positionId">
          <el-select v-model="form.positionId" placeholder="请选择" style="width:100%">
            <el-option v-for="p in positions" :key="p.id" :label="`${p.name} (${p.code})`" :value="p.id" />
          </el-select>
        </el-form-item>

        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="后台管理用,用户不可见" maxlength="100" />
        </el-form-item>

        <el-form-item label="副标题">
          <el-input v-model="form.subTitle" placeholder="可选,部分前端样式会展示" maxlength="200" />
        </el-form-item>

        <el-form-item label="图片URL" prop="imageUrl">
          <el-input v-model="form.imageUrl" placeholder="https://... 或 XXXX.jpg" />
          <el-upload
            class="upload-inline"
            action=""
            :http-request="bannerUpload"
            :show-file-list="false"
            :before-upload="beforeUpload"
            accept="image/*"
          >
            <el-button size="mini" type="primary" icon="el-icon-upload">上传图片</el-button>
          </el-upload>
        </el-form-item>

<!--        <el-form-item label="移动端图片">-->
<!--          <el-input v-model="form.imageUrlMobile" placeholder="不填则复用上方图片" />-->
<!--        </el-form-item>-->

        <el-form-item label="跳转类型" prop="linkType">
          <el-select v-model="form.linkType" style="width:100%">
            <el-option :value="1" label="无跳转" />
            <el-option :value="2" label="内部页面(路由path)" />
            <el-option :value="3" label="外部链接(URL)" />
            <el-option :value="4" label="小程序页面" />
          </el-select>
        </el-form-item>

        <el-form-item label="跳转地址">
          <el-input v-model="form.linkUrl" placeholder="跳转地址" />
        </el-form-item>

<!--        <el-form-item label="跳转参数(JSON)">-->
<!--          <el-input v-model="form.linkParam" placeholder='{"productId":123}' type="textarea" :rows="2" />-->
<!--        </el-form-item>-->

        <el-form-item label="排序权重">
          <el-input-number v-model="form.sortOrder" :min="0" :max="9999" />
          <span class="tip">越大越靠前</span>
        </el-form-item>

        <el-form-item label="生效时间">
          <el-date-picker
            v-model="timeRange"
            type="datetimerange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width:100%"
          />
          <div class="tip">不填=立即生效 / 永久有效</div>
        </el-form-item>

        <el-form-item label="背景色">
          <el-color-picker v-model="form.backgroundColor" />
          <span class="tip">{{ form.backgroundColor }}</span>
        </el-form-item>

        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="0">草稿</el-radio>
            <el-radio :label="1">已发布</el-radio>
            <el-radio :label="2">已下架</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="运营备注(仅后台可见)" />
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getBannerPage, addBanner, updateBanner, deleteBanner, publishBanner, offlineBanner } from '@/api/banner'
import { uploadImage } from '@/api/upload'

export default {
  name: 'Banner',
  data() {
    return {
      // 搜索
      query: { pageNum: 1, pageSize: 10, positionId: null, status: null, keyword: '' },
      tableData: [],
      total: 0,
      loading: false,

      // 运营位下拉(实际应从接口获取,这里先写死常见项)
      positions: [
        { id: 1, code: 'home_top', name: '首页顶部轮播' },
        // { id: 2, code: 'home_middle', name: '首页中部横幅' },
        // { id: 3, code: 'merchant_top', name: '商家页顶部' },
        // { id: 4, code: 'activity_pop', name: '活动弹窗' }
      ],

      // 弹窗
      dialogVisible: false,
      dialogTitle: '新增 Banner',
      submitting: false,
      form: this.emptyForm(),
      timeRange: [],
      rules: {
        positionId: [{ required: true, message: '请选择运营位', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        imageUrl: [{ required: true, message: '请输入图片URL', trigger: 'blur' }],
        linkType: [{ required: true, message: '请选择跳转类型', trigger: 'change' }]
      },

      uploadUrl: '/manage/banner/uploadPic'
    }
  },

  mounted() {
    this.fetchList()
  },

  methods: {
    emptyForm() {
      return {
        id: null,
        positionId: null,
        title: '',
        subTitle: '',
        imageUrl: '',
        imageUrlMobile: '',
        linkType: 1,
        linkUrl: '',
        linkParam: '',
        sortOrder: 0,
        status: 0,
        startTime: null,
        endTime: null,
        backgroundColor: '#ffffff',
        remark: ''
      }
    },

    fetchList() {
      this.loading = true
      getBannerPage(this.query).then(res => {
        this.tableData = res.records || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    handleSearch() {
      this.query.pageNum = 1
      this.fetchList()
    },

    resetQuery() {
      this.query = { pageNum: 1, pageSize: 10, positionId: null, status: null, keyword: '' }
      this.fetchList()
    },

    handleAdd() {
      this.dialogTitle = '新增 Banner'
      this.form = this.emptyForm()
      this.timeRange = []
      this.dialogVisible = true
    },

    handleEdit(row) {
      this.dialogTitle = '编辑 Banner'
      this.form = { ...row }
      this.timeRange = row.startTime && row.endTime ? [row.startTime, row.endTime] : []
      this.dialogVisible = true
    },

    handleSubmit() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        // 时间范围拆分
        if (this.timeRange && this.timeRange.length === 2) {
          this.form.startTime = this.timeRange[0]
          this.form.endTime = this.timeRange[1]
        } else {
          this.form.startTime = null
          this.form.endTime = null
        }

        const isEdit = !!this.form.id
        const action = isEdit ? updateBanner(this.form) : addBanner(this.form)

        this.submitting = true
        action.then(res => {
          if (res) {
            this.$message.success(isEdit ? '修改成功' : '新增成功')
            this.dialogVisible = false
            this.fetchList()
          } else {
            this.$message.error((isEdit ? '修改' : '新增') + '失败')
          }
        }).finally(() => {
          this.submitting = false
        })
      })
    },

    handlePublish(row) {
      this.$confirm(`确认上架「${row.title}」?`, '提示', { type: 'warning' }).then(() => {
        publishBanner(row.id).then(res => {
          if (res) { this.$message.success('已上架'); this.fetchList() }
        })
      })
    },

    handleOffline(row) {
      this.$confirm(`确认下架「${row.title}」?`, '提示', { type: 'warning' }).then(() => {
        offlineBanner(row.id).then(res => {
          if (res) { this.$message.success('已下架'); this.fetchList() }
        })
      })
    },

    handleDelete(row) {
      this.$confirm(`确认删除「${row.title}」? 此操作不可恢复!`, '危险操作', { type: 'error' }).then(() => {
        deleteBanner(row.id).then(res => {
          if (res) { this.$message.success('已删除'); this.fetchList() }
        })
      })
    },

    handleUploadSuccess(response) {
      if (response && response.data) {
        this.form.imageUrl = response.data.fileUrl;
        this.$message.success('上传成功')
      }
    },

    beforeUpload(file) {
      const isImg = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImg) this.$message.error('只能上传图片!')
      if (!isLt2M) this.$message.error('图片不能超过 2MB!')
      return isImg && isLt2M
    },

    bannerUpload({ file }) {
      this.uploading = true
      uploadImage(file)
          .then(res => {
            if (res) {
              // 后端返回结构假设是 { code:200, data:{ fileUrl:'xxx' } }
              this.form.imageUrl = res.fileUrl;
              this.$message.success('上传成功')
            } else {
              this.$message.error(res.message || '上传失败')
            }
          })
          .catch(() => {
            this.$message.error('上传失败')
          })
          .finally(() => {
            this.uploading = false
          })
    },

    resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },

    statusTagType(status) {
      return { 0: 'info', 1: 'success', 2: 'danger' }[status] || ''
    },

    formatTime(t) {
      return t ? String(t).replace('T', ' ').slice(0, 16) : ''
    }
  }
}
</script>

<style scoped>
.banner-manage { padding: 16px; }
.search-bar { margin: 16px 0; }
.toolbar { margin-bottom: 12px; }
.pagination { margin-top: 16px; text-align: right; }
.tip { color: #909399; font-size: 12px; margin-left: 8px; }
.upload-inline { display: inline-block; margin-left: 10px; vertical-align: middle; }
</style>
